// Each tint keeps the white initials at 5:1 or better (WCAG 1.4.3).
const AVATAR_PALETTE = ["#7A4A9E", "#1F6CB0", "#2E7D32", "#A8541C", "#636366"];

/** Deterministic colour per person so the same initials always get the same tint. */
export function avatarColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) & 0xffff;
  }
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

export function getInitials(
  firstName?: string,
  lastName?: string,
  fallbackName?: string,
): string {
  const f = firstName?.trim();
  const l = lastName?.trim();
  if (f || l) {
    return `${f?.[0] ?? ""}${l?.[0] ?? ""}`.toUpperCase();
  }
  const parts = (fallbackName ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
